import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PortalApiService } from '../../portal-api.service';
import { PortalAuthService } from '../../portal-auth.service';
import { PortalBrandingService } from '../../portal-branding.service';

@Component({
	selector: 'portal-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['../login/login.component.scss']
})
export class ResetPasswordComponent implements OnInit {

	token = '';
	reset: any = null;
	loadingToken = true;
	loadError = '';

	password = '';
	passwordConf = '';
	error = '';
	submitting = false;

	constructor(
		private route: ActivatedRoute,
		private api: PortalApiService,
		private auth: PortalAuthService,
		public branding: PortalBrandingService,
		private router: Router
	) {}

	get coverUrl(): string | null { return this.branding.loginCoverUrl; }

	ngOnInit(): void {
		this.token = this.route.snapshot.paramMap.get('token') || '';
		if (!this.token) {
			this.loadingToken = false;
			this.loadError = 'Invalid reset link.';
			return;
		}

		this.api.auth.resetDetails(this.token, (res: any) => {
			this.loadingToken = false;
			this.reset = res?.reset || null;
			this.branding.apply(res?.branding);
		}, (err: any) => {
			this.loadingToken = false;
			this.loadError = err?.message || 'This reset link is no longer valid.';
		});
	}

	submit(): void {
		this.error = '';
		if (this.password.length < 7) { this.error = 'Password must be at least 7 characters long.'; return; }
		if (this.password !== this.passwordConf) { this.error = 'Please enter the same password twice to confirm.'; return; }

		this.submitting = true;
		this.api.auth.resetPassword({
			token: this.token,
			password: this.password,
			password_conf: this.passwordConf
		}, (res: any) => {
			this.submitting = false;
			this.branding.apply(res?.branding);
			this.auth.setUser(res?.user || null);
			this.router.navigate(['/']);
		}, (err: any) => {
			this.submitting = false;
			this.error = err?.message || 'We could not reset your password.';
		});
	}
}
